import { storyblokEditable } from "@storyblok/react/rsc";
import { FC } from "react";
import { AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FaqItemStoryblok } from "@/types/sb-component-types";
interface FAQItemProps {
  blok: FaqItemStoryblok;
}
export const FAQItem: FC<FAQItemProps> = ({
  blok
}) => {
  return <AccordionItem value={blok._uid} {...storyblokEditable(blok)} data-sentry-element="AccordionItem" data-sentry-component="FAQItem" data-sentry-source-file="FAQItem.tsx">
      <AccordionTrigger data-sentry-element="AccordionTrigger" data-sentry-source-file="FAQItem.tsx">{blok.question}</AccordionTrigger>
      <AccordionContent data-sentry-element="AccordionContent" data-sentry-source-file="FAQItem.tsx">
        <div className="prose prose-sm max-w-none">
          <p>{blok.answer}</p>
        </div>
      </AccordionContent>
    </AccordionItem>;
};